import { render, staticRenderFns } from "./commonPage.vue?vue&type=template&id=5df08f10&scoped=true&"
import script from "./commonPage.vue?vue&type=script&lang=js&"
export * from "./commonPage.vue?vue&type=script&lang=js&"
import style0 from "./commonPage.vue?vue&type=style&index=0&id=5df08f10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df08f10",
  null
  
)

export default component.exports